import { useEffect } from "react";

export default function ChatBot() {
  useEffect(() => {
    if (window.mountChatBot) {
      window.mountChatBot("chatBot");
    }
  }, []);

  return <div id="chatBot"></div>;
}